import { KeycloakService } from 'keycloak-angular';

export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
    return () =>
        keycloak.init({
            config: {
                url: 'https://sso.vnuhcm.edu.vn/auth',
                realm: 'Production',
                clientId: 'webapp-ctsv',
                // realm: 'test1',
                // clientId: 'webapp1',
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false,
            },
            loadUserProfileAtStartUp: true,
        });
}
